// Lib
import React from 'react';
import PropTypes from 'prop-types';
import { capitalize, lowercase } from 'lodash/fp';

// Components
import ElementTool from './ElementTool';
import RequireElementTypeEditPermission from './RequireElementTypeEditPermission';
import Icon from '../../../../components/icons/Icon';

const getToolName = (linkType) => capitalize(linkType);

const getDefaultContent = (linkType) => () => ({
    linkType,
});

const LinkTypeTool = ({ item, currentBoardId, gridSize, selectOnCreate, currentUserId, permissions, ...rest }) => {
    const elementTypeObject = item?.toolSettings?.elementTypeObject || rest.elementTypeObject || {};
    const linkType = item?.toolSettings?.linkType || rest.linkType || 'line';

    return (
        <RequireElementTypeEditPermission elementType={elementTypeObject.elementType} permissions={permissions}>
            <ElementTool
                {...rest}
                className={undefined}
                key={elementTypeObject.elementType}
                name={getToolName(linkType)}
                elementType={elementTypeObject.elementType}
                currentBoardId={currentBoardId}
                currentUserId={currentUserId}
                gridSize={gridSize}
                icon={<Icon name={`element-${lowercase(linkType)}`} gridSize={gridSize} />}
                selectOnCreate={selectOnCreate}
                getDefaultContent={getDefaultContent(linkType)}
            />
        </RequireElementTypeEditPermission>
    );
};

LinkTypeTool.propTypes = {
    currentBoardId: PropTypes.string.isRequired,
    currentUserId: PropTypes.string.isRequired,
    elementTypeObject: PropTypes.object,
    permissions: PropTypes.number.isRequired,
    gridSize: PropTypes.number.isRequired,
    selectOnCreate: PropTypes.bool,
    customOnDrop: PropTypes.func,
    linkType: PropTypes.string,
    item: PropTypes.object,
};

export default LinkTypeTool;
